import React, {Component} from "react";
import {constants} from "../data/constants"
import {downLoadVisit} from "../data/analytics";

export class Pricing extends Component {
	render() {
		return (
			<div id="price" className="text-center">
				<div className="container">
					<div className="section-title">
						<h2>Pricing</h2>
						<p>
							Enjoy a FREE trial period and continue tracking your hours with our affordable subscriptions
						</p>
					</div>
					<div className={"row mb-5"}>
						{this.props.data && this.props.data.map((item, i) => (
							<div className={"col-md-4"}>
								<div className="card text-center shadow">
									<div className="card-header">
										<h3>{item.plan}</h3>
										<h5>${item.price}</h5>
									</div>

									{item.promo && item.promo && (
										<div className="card-body">
											<h5 className="card-title text-success">
												{item.promo}
											</h5>
										</div>
									)}
									<ul className="list-group list-group-flush">
										{item.text.map((text, i) => (
											<li className="list-group-item">{text}</li>
										))}
									</ul>
								</div>
							</div>
						))}
					</div>


					<div className={"text-center mt-5"}>
						<h2>
							Start your FREE 15-day trial today
						</h2>

						<div className="row justify-content-center mt-5">
							<a onClick={() => downLoadVisit('ios', this.props.source)}>
								<img src="img/app-store.svg" height="45" width="auto" alt="Appstore download image"/>
							</a>
							<span className="download-space"></span>
							<a onClick={() => downLoadVisit('android', this.props.source)}>
								<img src="img/play-store.svg" height="45" width="auto" alt="Playstore download image"/>
							</a>
						</div>
					</div>

				</div>
			</div>
		)
	}
}

export default Pricing;



// WEBPACK FOOTER //
// ./src/components/Pricing.jsx